import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { AddPeerTimingRequest } from '../../models/peer/addPeerTimingRequest';
import { PeerTimingResponse } from '../../models/peer/peerTimingResponse';
import { Observable } from 'rxjs';
import { GetAllPeerTimingResponse } from '../../models/peer/getAllPeerTimingResponse';
import { apiResponse } from '../../models/apiResponse';
import { GetPeerTimingRequest } from '../../models/peer/getPeerTimingRequest';

@Injectable({
  providedIn: 'root'
})
export class PeerTimingsService {

  constructor(private genericService: GenericService) { }

  addPeerTiming(addPeerTimingRequest: AddPeerTimingRequest): Observable<PeerTimingResponse>
  {
    return this.genericService.post(`peertimings`, addPeerTimingRequest);
  }
  getAllPeerTimings(peerId: string): Observable<apiResponse<GetAllPeerTimingResponse>>
  {
    return this.genericService.get(`peertimings/${peerId}`);
  }
  getPeerTimings(getPeerTimingRequest: GetPeerTimingRequest): Observable<PeerTimingResponse>
  {
    return this.genericService.post(`peertimingsbydayandid`, getPeerTimingRequest);
  }
  deletePeerTiming(timeSlotId: number): Observable<PeerTimingResponse>
  {
    return this.genericService.delete(`peertimings/${timeSlotId}`);
  }
}
